import type { WidgetLink, WidgetSettings } from "@productlane/db/browser"

// postMessage contract between the dashboard's widget preview and the embedded
// preview page it hosts. The page relays the payload into the widget iframe.
export const WIDGET_PREVIEW_SETTINGS_MESSAGE = "productlane:preview-settings"

// The widget renders only these four columns of a link.
export type WidgetLinkView = Pick<WidgetLink, "id" | "title" | "url" | "icon">

// Copy shown in the AI chat view, so edits reach the preview without a reload.
export interface AiChatPreviewSettings {
	welcomeMessage?: string
	exampleQuestions?: string[]
}

export interface WidgetPreviewSettings {
	widgetSettings?: Partial<WidgetSettings>
	widgetLinks?: WidgetLinkView[]
	aiChatSettings?: AiChatPreviewSettings
}

export interface WidgetPreviewSettingsMessage {
	type: typeof WIDGET_PREVIEW_SETTINGS_MESSAGE
	previewSettings: WidgetPreviewSettings
}

export function isWidgetPreviewSettingsMessage(
	data: unknown,
): data is WidgetPreviewSettingsMessage {
	return (
		typeof data === "object" &&
		data !== null &&
		(data as { type?: unknown }).type === WIDGET_PREVIEW_SETTINGS_MESSAGE &&
		typeof (data as { previewSettings?: unknown }).previewSettings === "object"
	)
}

// The preview page and the dashboard frame around it paint the same canvas, so
// the iframe never flashes the marketing site's near-black body on load.
export const WIDGET_PREVIEW_BACKGROUND = {
	light: "#EDEDED",
	dark: "#151518",
} as const

export type WidgetPreviewMode = keyof typeof WIDGET_PREVIEW_BACKGROUND
